import React from 'react';

var AddressLink = React.createClass({

  render: function(){
    var item = this.props.item;
    var address = !item.address ? '' : item.address.replace(/, United States$/, '');
    var mapQuery = item.name + ', ' + address;
    var iOS = /(iPad|iPhone|iPod)/g.test( navigator.userAgent );
    var mapService = iOS ? 'apple' : 'google';
    var markerPin = (this.props.dayIndex > 0) ? <div className={"marker-pin day_" + this.props.dayIndex }>{item.placeIndex}</div> : null ;
    
    if (this.props.isSmallScreen) {
      address = <span>{markerPin} Address </span>;
    }

    return (
      <div className="sub-header">
        <address>
          <a href={"http://maps." + mapService + ".com/?q="+ mapQuery } target="_blank" className="locationMapLink url">
            {address}
          </a>
        </address>
      </div>
    );
  }
});

module.exports = AddressLink;



// WEBPACK FOOTER //
// ./components/address-link.js